const MISSING = '—';

const nairaFormatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 2,
});

const countFormatter = new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 });

const percentFormatter = new Intl.NumberFormat('en-NG', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatNaira = (amount) => {
  const value = toNumber(amount);
  return value === null ? MISSING : nairaFormatter.format(value);
};

export const grossAmount = ({ amount, discount_amount: discount }) => {
  const net = toNumber(amount);
  return net === null ? null : net + (toNumber(discount) ?? 0);
};

export const formatCount = (n) => {
  const value = toNumber(n);
  return value === null ? MISSING : countFormatter.format(Math.round(value));
};

export const formatPercent = (n) => {
  const value = toNumber(n);
  return value === null ? MISSING : `${percentFormatter.format(value)}%`;
};

const unitFormatters = {
  currency: formatNaira,
  count: formatCount,
  percent: formatPercent,
  percentage: formatPercent,
};

export const formatMetric = ({ unit, value }) => {
  const format = unitFormatters[unit];
  if (format) return format(value);
  return value === null || value === undefined ? MISSING : String(value);
};
